import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faStore, faCheckCircle, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import './GetStarted.css';

const GetStarted = () => {
    return (
        <main className="get-started">
            <div className="container">
                <header className="get-started-header">
                    <h1>Choose Your Path</h1>
                    <p>Tell us a little about what you're looking for and we'll get you started right away.</p>
                </header>

                <div className="selection-tiles">
                    <div className="selection-tile buyer-tile">
                        <div className="tile-content">
                            <FontAwesomeIcon icon={faShoppingCart} className="tile-icon" />
                            <h2>I'm Looking to Buy</h2>
                            <p>Find exactly what you're looking for with our network of verified sellers.</p>
                            
                            <div className="benefits-list">
                                <h3>Buyer Benefits</h3>
                                <ul>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Access to exclusive listings
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Verified sellers only
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Personalized matches
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Secure transactions
                                    </li>
                                </ul>
                            </div>

                            <Link to="/buyers/create_lead" className="tile-button">
                                Start Buying
                            </Link>
                        </div>
                    </div>

                    <div className="selection-tile seller-tile">
                        <div className="tile-content">
                            <FontAwesomeIcon icon={faStore} className="tile-icon" />
                            <h2>I'm Looking to Sell</h2>
                            <p>Connect with qualified buyers who are actively looking for what you're selling.</p>
                            
                            <div className="benefits-list">
                                <h3>Seller Benefits</h3>
                                <ul>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Verified buyers only
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Quick matching process
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Secure payment handling
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                                        Professional support
                                    </li>
                                </ul>
                            </div>

                            <Link to="/sellers/create_lead" className="tile-button">
                                Start Selling
                            </Link>
                        </div>
                    </div>
                </div>
                
                <div className="login-section">
                    <Link to="/login" className="login-link">
                        <FontAwesomeIcon icon={faSignInAlt} /> Already signed up? Login here
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default GetStarted; 